var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#9D9D9D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    clipPath: "url(#clip0_721_23627)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 944,
    transform: "translate(-911 -393)",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000014026"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8396",
    x: -636.5,
    y: -190.5,
    width: 666,
    height: 374,
    rx: 5.5,
    fill: "white",
    stroke: "#E6EDF0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000013987"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000013932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000013853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 21",
    opacity: 0.3,
    filter: "url(#filter0_f_721_23627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-566 76.4393C-556.81 74.2954 -538.486 89.8934 -525.944 83.0329C-510.267 74.4572 -499.528 31.5824 -447.632 42.3019C-395.736 53.0215 -400.121 42.7303 -382.823 45.7319C-368.984 48.1332 -349.226 79.0121 -337.333 86.3014C-328.143 93.019 -309.243 90.3234 -292.809 68.0267C-272.267 40.1559 -224.595 37.1564 -207.296 45.7319C-189.998 54.3074 -161.49 24.7232 -150.138 25.5808C-138.785 26.4384 -102.111 70.1721 -58.3239 50.4481C-23.2941 34.6689 -8.29769 57.5727 14.587 68.2923",
    stroke: "#F6B863",
    strokeWidth: 3.42998,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 19",
    filter: "url(#filter1_f_721_23627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-566 39.5661C-556.81 37.4222 -535.295 31.4193 -522.753 24.5587C-507.076 15.9831 -503.292 5.26352 -451.396 15.9831C-399.5 26.7026 -407.609 21.5571 -390.31 24.5587C-376.471 26.96 -349.226 42.1389 -337.333 49.4282C-328.143 56.1458 -305.655 64.0069 -289.221 41.7102C-268.679 13.8393 -237.325 -1.16797 -220.026 7.40756C-202.728 15.9831 -168.671 37.8509 -157.319 38.7084C-145.966 39.566 -141.642 38.7084 -97.8544 18.9844C-62.8246 3.20523 -32.8847 8.26486 -10 18.9844",
    stroke: "#11C89B",
    strokeOpacity: 0.22,
    strokeWidth: 3.42998,
    strokeLinecap: "round"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000015387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union",
    filter: "url(#filter2_d_721_23627)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_721_23627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.54 -327L320.148 -337L311.042 -327H-25C-27.2091 -327 -29 -325.209 -29 -323V452C-29 454.209 -27.2091 456 -25 456H417C419.209 456 421 454.209 421 452V-323C421 -325.209 419.209 -327 417 -327H328.54Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.54 -327L320.148 -337L311.042 -327H-25C-27.2091 -327 -29 -325.209 -29 -323V452C-29 454.209 -27.2091 456 -25 456H417C419.209 456 421 454.209 421 452V-323C421 -325.209 419.209 -327 417 -327H328.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.148 -337L320.914 -337.643L320.179 -338.519L319.409 -337.673L320.148 -337ZM328.54 -327L327.774 -326.357L328.074 -326H328.54V-327ZM311.042 -327V-326H311.484L311.781 -326.327L311.042 -327ZM319.382 -336.357L327.774 -326.357L329.306 -327.643L320.914 -337.643L319.382 -336.357ZM311.781 -326.327L320.888 -336.327L319.409 -337.673L310.303 -327.673L311.781 -326.327ZM-25 -326H311.042V-328H-25V-326ZM-28 -323C-28 -324.657 -26.6569 -326 -25 -326V-328C-27.7614 -328 -30 -325.761 -30 -323H-28ZM-28 452V-323H-30V452H-28ZM-25 455C-26.6569 455 -28 453.657 -28 452H-30C-30 454.761 -27.7614 457 -25 457V455ZM417 455H-25V457H417V455ZM420 452C420 453.657 418.657 455 417 455V457C419.761 457 422 454.761 422 452H420ZM420 -323V452H422V-323H420ZM417 -326C418.657 -326 420 -324.657 420 -323H422C422 -325.761 419.761 -328 417 -328V-326ZM328.54 -326H417V-328H328.54V-326Z",
    fill: "#F0F0F0",
    mask: "url(#path-4-inside-1_721_23627)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000015213",
    clipPath: "url(#clip1_721_23627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000015217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flags"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#667085",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("g", {
    id: "announcement"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.65392 18.3728C6.69432 18.4627 6.76568 18.5351 6.85498 18.5768C6.94428 18.6185 7.04559 18.6267 7.14045 18.6L8.47485 18.2424C8.5324 18.2265 8.58578 18.1982 8.63129 18.1595C8.6768 18.1209 8.71334 18.0728 8.73837 18.0186C8.76392 17.9653 8.7777 17.9072 8.77878 17.8481C8.77985 17.7891 8.76819 17.7305 8.74458 17.6764L6.56097 12.8471L7.04548 12.7173C13.23 11.6518 16.8072 14.4859 16.8396 14.5113C16.8904 14.5533 16.9506 14.5824 17.015 14.5963C17.0795 14.6101 17.1463 14.6082 17.2099 14.5908C17.2508 14.5811 17.2895 14.5635 17.3237 14.5391C17.3973 14.4923 17.4541 14.4233 17.4859 14.342C17.5177 14.2608 17.5229 14.1716 17.5006 14.0873L16.3141 9.65913L17.1441 9.43673C17.2495 9.4085 17.3393 9.33959 17.3938 9.24516C17.4483 9.15072 17.4631 9.0385 17.4349 8.93317L16.6676 6.06976C16.6394 5.96443 16.5705 5.87463 16.4761 5.82011C16.3816 5.76559 16.2694 5.75081 16.1641 5.77903L15.334 6.00144L14.1539 1.59712C14.1306 1.51859 14.0843 1.44881 14.0211 1.39675C13.9578 1.34468 13.8805 1.31269 13.7989 1.30489C13.7125 1.2995 13.6265 1.32156 13.5533 1.36792C13.4801 1.41429 13.4234 1.48259 13.3914 1.56307C13.3742 1.61024 11.5019 6.15567 5.74029 8.05278L3.278 8.71255C2.9521 8.79984 2.67372 9.01201 2.50314 9.30311C2.33256 9.5942 2.28353 9.94077 2.36667 10.2678L2.96046 12.4838C3.04393 12.792 3.2397 13.0579 3.50928 13.2291C3.77885 13.4002 4.10271 13.4643 4.41717 13.4088L6.65392 18.3728ZM7.7934 17.5737L7.26122 17.7163L5.22656 13.2047L5.75874 13.0621L7.7934 17.5737ZM15.9798 6.67974L16.5299 8.73297L16.097 8.84896L15.5469 6.79573L15.9798 6.67974ZM13.6363 2.84252L16.4254 13.2516C14.9513 12.4207 11.787 11.1276 7.18349 11.8503L6.33856 8.69696C9.38243 7.6617 11.9656 5.58944 13.6363 2.84252ZM3.75475 12.271L3.16096 10.0549C3.12935 9.93696 3.1459 9.81127 3.20696 9.7055C3.26803 9.59973 3.36861 9.52256 3.48658 9.49095L5.55172 8.93759L6.38388 12.0433L4.31873 12.5966C4.20077 12.6282 4.07507 12.6117 3.96931 12.5506C3.86354 12.4895 3.78636 12.389 3.75475 12.271Z",
    fill: "#667085"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-29 -18H420V-20H-29V-18ZM420 90H-29V92H420V90Z",
    fill: "#F4F4F4",
    mask: "url(#path-6-inside-2_721_23627)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_721_23627",
    x: -579.72,
    y: 11.8427,
    width: 608.028,
    height: 91.4283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.00246,
    result: "effect1_foregroundBlur_721_23627"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_721_23627",
    x: -579.72,
    y: -8.72098,
    width: 583.44,
    height: 78.8904,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.00246,
    result: "effect1_foregroundBlur_721_23627"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_721_23627",
    x: -57,
    y: -361,
    width: 506,
    height: 849,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_721_23627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_721_23627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_23627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 944,
    fill: "white",
    transform: "translate(-911 -393)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_721_23627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 449,
    height: 693,
    fill: "white",
    transform: "translate(-29 -237)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.1891e37474ee3e1855b696cdf9717870.svg";
export { ForwardRef as ReactComponent };